import { getSiteOrigin } from './getSiteOrigin'

export type BreadcrumbItem = { name: string; path: string }

function absoluteUrl(origin: string, path: string) {
  if (/^https?:\/\//i.test(path)) return path
  const p = path.startsWith('/') ? path : `/${path}`
  return `${origin}${p}`
}

export function buildBreadcrumbJsonLd(items: BreadcrumbItem[]) {
  const origin = getSiteOrigin()
  if (!origin || items.length === 0) return undefined

  return {
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: absoluteUrl(origin, item.path)
    }))
  }
}
